import { Card } from 'flowbite-react';
import { Tabs } from '@acme/foundation';
import { operationsColumns, tabsTheme, OperationItem } from '../../config';
import { OperationsTab } from './tab';

const operations: OperationItem[] = [
  {
    id: 1,
    application: { name: 'АБВ-123456-789', id: '1' },
    type: 'Пополнение',
    address: 'EJgH1Cey379sTCe2WDYsois3nm9z5dMUwtGY8t5EzQMV',
    sum: { value: 150000, currency: 'USD' },
    date: '2026-02-27T12:35:00',
    pay: '2027-02-27T12:35:00',
  },
  {
    id: 2,
    application: { name: 'АБВ-123456-111', id: '1' },
    type: 'Пополнение',
    address: 'EJgH1Cey379sTCe2WDYsois3nm9z5dMUwtGY8t5EzQMV',
    sum: { value: 20, currency: 'USD' },
    date: '2026-02-27T12:35:00',
    pay: '2027-02-27T12:35:00',
  },
  {
    id: 3,
    application: { name: 'АБВ-123456-111', id: '1' },
    type: 'Пополнение',
    address: 'EJgH1Cey379sTCe2WDYsois3nm9z5dMUwtGY8t5EzQMV',
    sum: { value: 20, currency: 'USD' },
    date: '2026-02-27T12:35:00',
    pay: '2027-02-27T12:35:00',
  },
];

export const OperationsHistory = () => {
  return (
    <Card className="[&>div]:px-0 [&>div]:pb-0">
      <h2 className="text-xl font-semibold px-6 mb-6">История операций</h2>

      <Tabs
        theme={tabsTheme}
        items={[
          {
            key: 'by-account',
            title: 'По счету',
            content: (
              <OperationsTab
                columns={operationsColumns('account')}
                method={() =>
                  Promise.resolve({
                    data: { items: operations, totalCount: 100 },
                  })
                }
              />
            ),
          },
          {
            key: 'by-crypto',
            title: 'По криптокошелькам',
            content: (
              <OperationsTab
                columns={operationsColumns('crypto')}
                method={() =>
                  Promise.resolve({
                    data: { items: operations, totalCount: 2 },
                  })
                }
              />
            ),
          },
        ]}
      />
    </Card>
  );
};
